// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3804) return "static/chunks/3804-6daf4111c37c3a9f.js";
	if (chunkId === 6603) return "static/chunks/a342680c-895b2a7c4d8a86e6.js";
	if (chunkId === 1089) return "static/chunks/1089-c4410c9fd374d2eb.js";
	if (chunkId === 3668) return "static/chunks/3668-59f9f7f7729f70cf.js";
	if (chunkId === 8087) return "static/chunks/8087-b5931f336ec40d8a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1910 ? "4e6af11a" : chunkId) + "." + {"1910":"f0b912f2417d7a18","5201":"00f95bb8bf22f71c","6034":"8e5327ac942a4dc9","8110":"a9d736eeba37e350","9108":"7b2aaa474b6afc2c"}[chunkId] + ".js";
};